import { useState, useEffect } from "react";
import { FiPlay } from "react-icons/fi";
import { FaInstagram } from "react-icons/fa6";

const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [visiblePosts, setVisiblePosts] = useState(3);

  const ACCESS_TOKEN =
    "IGAARRP62RuoxBZAE1ZARlR6M3p2SUVlN0d5OGFOcUZAMQ3RiM3BSeEg1aU1TNE1EdVdvUzlMLWFBZATM4eDVxTXBzSnoxMGR3eV95bWZAndndsQ3M5N0g0OEVXeHQzOTd6cHFDM3Mtc09rc0FhRDlvN1VtbEcwNk5oeHVLczgwYUttRQZDZD";
  const USER_ID = "9040415549391140";
  const API_URL = `https://graph.instagram.com/${USER_ID}/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${ACCESS_TOKEN}`;

  const fetchPosts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(API_URL);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      // Fetch additional details for each post
      const postsWithDetails = await Promise.all(
        data.data.slice(0, 18).map(async (post) => {
          const postResponse = await fetch(
            `https://graph.instagram.com/${post.id}?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${ACCESS_TOKEN}`
          );
          return postResponse.json();
        })
      );

      setPosts(postsWithDetails);
    } catch (err) {
      console.error("Error fetching Instagram posts:", err);
      setError("Failed to load Instagram posts. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const loadMorePosts = () => {
    setVisiblePosts((prev) => prev + 3);
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="instagram-feed-container">
      <div className="instagram-feed-inner">
        {/* Header */}
        <div className="feed-header">
          <div className="profile-info">
            <div className="d-flex align-items-center gap-2">
              <FaInstagram size={24} className="follow-icon" />
              <h3 className="mb-0">@elitebodyhomeuae</h3>
            </div>

            <p className="profile-subtitle">Beauty & Health Redefined</p>
            <div className="profile-bio">
              <p>
                💠Aesthetic 💠Dermatology 💠Laser 💠Slimming 💠Physiotherapy
                💠IV Therapy
              </p>
            </div>
          </div>
        </div>

        {/* Error Message */}
        {error && <div className="error-message">{error}</div>}

        {/* Loading Spinner */}
        {loading && posts.length === 0 && (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <span>Loading...</span>
          </div>
        )}

        {/* Posts Grid */}
        <div className="posts-grid">
          {posts.slice(0, visiblePosts).map((post) => (
            <div key={post.id} className="post-col">
              <div className="post-wrapper">
                <a
                  href={post.permalink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="post-link"
                >
                  {post.media_type === "VIDEO" && (
                    <div className="play-icon">
                      <FiPlay size={24} />
                    </div>
                  )}
                  <img
                    src={
                      post.media_type === "VIDEO"
                        ? post.thumbnail_url
                        : post.media_url
                    }
                    alt={post.caption || "Instagram post"}
                    className="post-image"
                    loading="lazy"
                  />
                  <div className="post-overlay">
                    <div className="post-caption">
                      {post.caption &&
                        (post.caption.length > 60
                          ? `${post.caption.substring(0, 60)}...`
                          : post.caption)}
                    </div>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {!loading && visiblePosts < posts.length && (
          <div className="load-more-container">
            <button onClick={loadMorePosts} className="load-more-btn">
              Load More
            </button>
          </div>
        )}

        {/* No Posts Message */}
        {!loading && posts.length === 0 && !error && (
          <div className="no-posts-message">
            <p>No Instagram posts available.</p>
          </div>
        )}

        {/* Follow Button */}
        <div className="follow-btn-container">
          <a
            href="https://www.instagram.com/elitebodyhomeuae/"
            target="_blank"
            rel="noopener noreferrer"
            className="follow-btn"
          >
            <FaInstagram size={24} className="follow-icon" />
            Follow on Instagram
          </a>
        </div>
      </div>
    </div>
  );
};

export default InstagramFeed;
